// extracted by mini-css-extract-plugin
export default {"connectWallet":"ZyqviPAiwVq3YDUtbi2m","connectWalletText":"PwjUnA7NtrPoMwC22wyh","hasCoinIcon":"ZIZKX_E1YdznS34JENwy"};